import { Box, Heading } from "@vinomofo/components";

import { Link } from "gatsby";
import styled from "styled-components";
import { tint } from "polished";

export interface NavigationButtonProps {
  active?: boolean;
  label: string;
  href: string;
  borderColor: string;
  count?: number;
}

const NavWrapper = styled(Box)`
  &:last-child {
    margin-right: 0;
  }
`;

const NavLink = styled(Link)`
  text-decoration: none;
  white-space: nowrap;
`;

const NavButton = styled(Box)<{ borderColor: string; active: boolean }>`
  background-color: ${({ borderColor, active }) =>
    active ? borderColor : "white"};

  &:hover {
    background-color: ${({ borderColor, active }) =>
      active ? tint(0.2, borderColor) : tint(0.9, borderColor)};
  }

  h3,
  p {
    padding-left: 10px;
    color: ${({ theme, active }) =>
      active ? theme.colors.white : theme.colors.black};
  }
  @media ${({ theme }) => theme.mq.max.tablet} {
    min-width: auto;
    justify-content: center;
    p {
      display: none;
    }
    h3 {
      justify-content: center;
      padding: 0 20px;
    }
  }
`;

export const NavigationButton = ({
  label,
  href,
  borderColor,
  active = false,
  count,
}: NavigationButtonProps): JSX.Element => {
  return (
    <NavWrapper mr={["8px", "16px"]} flexGrow={1}>
      <NavLink to={href}>
        <NavButton
          display="flex"
          border="2px solid"
          borderColor={borderColor}
          padding={["8px", "11px 20px"]}
          borderRadius={100}
          textAlign="center"
          minWidth={["150px", "150px", "180px"]}
          height="100%"
          alignItems="center"
          justifyContent="space-between"
          active={active}
        >
          <Heading fontSize={["14px", "18px"]} as="h3">
            {label}
          </Heading>
          <Heading fontSize={["12px", "12px"]} as="p">
            {count || ""}
          </Heading>
        </NavButton>
      </NavLink>
    </NavWrapper>
  );
};
